import ToastMessageType from "@/constants/enums/ToastMessageType";

/**
 * Cria o estado vazio da página FrequencyTrendLimitConfiguration.
 */
const EmptyState = function()
{
	return {
		availableAssets: [],
		toast:           {
			show:    false,
			message: "",
			type:    ToastMessageType.ERROR
		}
	};
};

/**
 * Cria o estado da página FrequencyTrendLimitConfiguration.
 */
const State = function(newState = EmptyState())
{
	return {
		availableAssets: newState.availableAssets,
		toast:           {
			show:    newState.toast.show,
			message: newState.toast.message,
			type:    newState.toast.type
		}
	};
};

export default { EmptyState, State, };